<template lang="pug">
#email-scheduler(:class="{ 'more-composes': number_composes > 1 }")
  .scheduler__title {{ scheduler_header }}
  .scheduler__datepicker-wrapper
    .form-group
      label Selecione a data:
      datepicker(:inline='true',
                 :disabled='{to: yesterday, from: from_dates}',
                 language='pt-br',
                 v-model='due_on_date')
  .form-group.scheduler__default-times
    label Selecione o horário:
    .scheduler__default-time(v-for='time in default_times', 
                             @click='selectDefaultTime(time)',
                             :class='{ selected: isSelected(time) }') {{ time }}
    
  .form-group.time-to-send-picker-wrapper(:class="{ 'has-error' : errors.has('due_on_time') }")
    label Horário customizado:
    input.form-control(type='text',
                       name='due_on_time',
                       placeholder='HH:MM',
                       v-validate="'required|regex:^([0-2][0-9]:[0-5][0-9])$'",
                       v-mask="'##:##'",
                       v-model='due_on_time')
    transition-group(name='fade')
      .help-block(v-show="errors.has('due_on_time')", key="due_on_time") {{ errors.first('due_on_time') }}

  .form-group.time-to-send-picker-wrapper(v-if="is_meeting_schedule")
    label Lembrar convidados:
    div
      span.meeting-reminder-date {{ due_on_scheduler.format('DD/MM/YYYY') }} 
      | às 
      span.meeting-reminder-date {{ due_on_time }}

  .form-group.time-to-send-picker-wrapper(v-if="is_meeting_schedule")
    label Reunião marcada para:
    div
      span.meeting-date {{ task.due_on.format('DD/MM/YYYY') }} 
      | às 
      span.meeting-date {{ task.due_on.format('HH:mm') }}

  .scheduler__footer
    .btn-primary.btn-gray.btn(v-if="!is_meeting_schedule", @click='closeScheduler()') Cancelar
    .btn-primary.btn-save.btn(v-if="!is_meeting_schedule", @click='submit()', :disabled='loading') Agendar
</template>

<script>
export default {
  props: {
    task: {
      default: {}
    },

    number_composes: {
      default: 1
    },

    loading: {
      default: false
    },

    event: {
      default: {}
    }
  },

  data() {
    return {
      due_on_date: new Date,
      due_on_time: this.task ? this.task.due_on.format('hh:mm') : null,
      due_on_scheduler: this.task ? this.task.due_on : moment()
    }
  },

  methods: {
    selectDefaultTime(time){
      this.due_on_time = time
    },

    isSelected(time){
      return this.due_on_time == time
    },

    closeScheduler(){
      this.$emit('close-scheduler')
    },

    setDueOn(){
      if (this.due_on_time){
        var parts = this.due_on_time.split(':')
        this.due_on_scheduler = moment(this.due_on_date).hours(parts[0]).minutes(parts[1])

        if(this.is_meeting_schedule) {
          this.$emit('schedule-meeting-date', this.due_on_scheduler)
        }
      }
    },

    submit(){
      if (this.loading) {
        return false
      }
      this.$validator.validateAll().then(success => {
          if (success) { 
            return this.scheduleEmailSend() 
          }
      })
    },

    scheduleEmailSend() {
      this.$emit('schedule-email-send', this.due_on_scheduler)
    }
  },

  computed: {
    yesterday() {
      var date = new Date
      date.setDate(date.getDate() - 1)
      return date
    },

    from_dates() {
      var date = new Date
      if(this.is_meeting_schedule) {
        date = this.task.due_on.clone().toDate()
      } else {
        date.setDate(date.getDate() + 730)
      }

      return date
    },

    scheduler_header() {
      if(this.is_meeting_schedule) {
        return 'Agendar e-mail de lembrete de reunião'
      }

      return 'Agendar envio de E-mail'
    },

    is_meeting_schedule() {
      return event.originalEventName == 'Compose::Open::Schedule::Meeting'
    }
  },

  watch: {
    due_on_date() {
      this.setDueOn()
    },

    due_on_time() {
      this.setDueOn()
    }
  },

  mounted() {
    var due_on = this.due_on_scheduler.clone()
    if(this.is_meeting_schedule) {
      due_on = due_on.subtract(1, 'd')
    }

    if (due_on.toDate() < new Date) {
      this.due_on_date = new Date
    } else {
      this.due_on_date = due_on.toDate()
    }

    if(!this.task.undefined_time){
      this.due_on_time = due_on.format('HH:mm') 
    }
  },

  created() {
    this.tasks_resources = new TasksResource()
    this.default_times = ['08:00','09:30','11:00','13:30','14:00', '17:30']
  }
}
</script>

<style lang="sass">
@import "../../../assets/stylesheets/_variables.sass"

#email-scheduler
  position: fixed
  right: 587px
  width: 405px
  border-radius: 4px
  background-color: #ffffff
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5)
  bottom: 5px
  z-index: 1041
  
  .scheduler__default-times
    width: 40%
    float: left
    margin-top: 14px
    margin-bottom: 0px

    label
      float: left
      width: 100%
      margin-bottom: 7px

    .scheduler__default-time
      cursor: pointer
      float: left
      margin-right: 7px
      margin-bottom: 7px
      min-width: 46px
      text-align: center
      border: solid 1px #e2e2e2
      background-color: #ffffff
      padding: 6px
      font-size: 11px
      font-weight: normal
      color: #84919b

      &.selected
        color: white
        font-weight: 600
        border: solid 1px #e2e2e2
        background-color: #4a90e2

  &.more-composes
    right: 1077px

  label
    color: #1b4b74

  .scheduler__title
    border-radius: 4px 4px 0 0
    background-color: $button-blue
    font-size: 12px
    font-weight: 500
    font-style: normal
    font-stretch: normal
    line-height: normal
    letter-spacing: normal
    text-align: left
    color: #ffffff
    padding: 8px
    min-height: 32px

  .scheduler__datepicker-wrapper
    float: left
    margin: 14px 12px 0 14px
    width: unset
  
  .time-to-send-picker-wrapper
    float: left
    margin: 4px 14px 4px 0

    .help-block
      max-width: 149px
      font-size: 9px

    .form-control
      font-size: 10px
      border-radius: 1px
      width: 46px
      padding: 4px
      height: 29px
      text-align: center
  
  .calendar
    width: 216px
    margin: unset
    padding: 0px 10px 10px 10px
    border-radius: 2px

    header
      .prev:after
        border: 5px solid transparent
        border-right: 8px solid #1b4b74
      
      .next:after
        border: 5px solid transparent
        border-left: 8px solid #1b4b74


    .cell
      height: 27.7px
      line-height: 26px
      font-size: 11px
      border-radius: 3px

      &:hover
        border-color: $button-blue !important

      &.selected
        background-color: $button-blue !important
        
  .scheduler__footer
    float: left
    width: 100%
    padding: 6px 5.5px
    border-top: solid 1px #e2e2e2
    background-color: #f9f9f9
    text-align: right

    .btn
      font-size: 11px
      border-radius: 1px
      padding: 5px 12px

  .meeting-date
    color: $orange

  .meeting-reminder-date
    color: $reev-base-green
</style>




// WEBPACK FOOTER //
// scheduler.vue?15ae2364